/*
XXX_JSREFACTOR_XXX
todo @JSREFACTOR
    - possibly replace all instances with built-in async/await function
*/

import { getEndpoint } from 'root/utils/cors/getEndpoint';

const CORS = {
    /**
     * Make a X-Domain request to url and callback.
     *
     * @param url {String}
     * @param method {String} HTTP verb ('GET', 'POST', 'DELETE', etc.)
     * @param data {String} request body
     * @param callback {Function} to callback on completion
     * @param errback {Function} to callback on error
     */
    xdr: function (url, method, data, callback, errback, withCredentials = false) {
        let invocation;
        url = getEndpoint(url);

        if (XMLHttpRequest) {
            invocation = new XMLHttpRequest();

            if ('withCredentials' in invocation) {
                invocation.open(method, url, true);
                invocation.withCredentials = withCredentials;
                invocation.onerror = errback;
                invocation.setRequestHeader(
                    'Content-Type',
                    'application/x-www-form-urlencoded'
                );
                invocation.onreadystatechange = function () {
                    if (invocation.readyState === 4) {
                        if (invocation.status >= 200 && invocation.status < 400) {
                            callback(invocation.responseText, invocation.status);
                        } else {
                            errback(invocation.responseText, invocation.status);
                        }
                    }
                };
                invocation.send(data);
            }

            invocation.onerror = function () {
                errback(new Error('Network Interruption Error Occurred'));
            };
        } else if (XDomainRequest) {
            invocation = new XDomainRequest();
            invocation.open(method, url);
            invocation.onerror = errback;
            invocation.onload = function () {
                callback(invocation.responseText);
            };
            invocation.send(data);
        } else {
            errback(new Error('CORS not supported'));
        }
    },
};

export { CORS };
